import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MessageHubService } from 'src/app/shared/services/message-hub.service';
import * as LobbyStatusBarPageActions from './actions/lobby-status-bar-page.actions';
import * as MessageHubActions from '../../../state/actions/message-hub.actions';

@Injectable()
export class LobbyStatusBarEffects {

    constructor(private actions$: Actions, private messageHubService: MessageHubService,) { }

    subscribeToLobbySignInUsers$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyStatusBarPageActions.subscribeToStatusBarData),
                switchMap(action => {
                    this.messageHubService.subscribeToStatBarGroup({ TenantId: action.tenantId, LocationId: action.locationId });
                    return of(MessageHubActions.joinLobbyStatusBarActionComplete());
                })
            );
    });
}
